import {
  IndicationItem,
  IndicationSet,
  IndicationSetType,
} from 'features/indicationTriage'
import { GeckoInspection, GeckoMeasurement } from 'types'

export type InspectionStatus =
  | 'scheduled'
  | 'in_progress'
  | 'data_validation'
  | 'preliminary_results_available'
  | 'completed'
  // For legacy inspections missing CDS data - if we see an old inspection with no CDS, we mark it as 'closed'.
  // Closed also applies to inspections that were scheduled but did not happen.
  | 'closed'

export const INSPECTION_STATUS_LABELS: Record<InspectionStatus, string> = {
  scheduled: 'Scheduled',
  in_progress: 'In Progress',
  data_validation: 'Data Validation',
  preliminary_results_available: 'Preliminary Results Available',
  completed: 'Completed',
  closed: 'Closed',
}

export const statusLabelsAsEntries = Object.entries(
  INSPECTION_STATUS_LABELS
) as ReadonlyArray<[InspectionStatus, string]>

export interface InboxFilterState {
  statusFilters: ReadonlyArray<InspectionStatus>
  inspectionTypeFilters: ReadonlyArray<string>
  draLevelFilters: ReadonlyArray<number>
  dateRange?: {
    start: string
    end: string
  }
  searchText?: string
  showFutureInspections: boolean
}

export interface InboxPaginationState {
  currentPage: number
  pageSize: number
  total: number
}

export type InboxSortDirection = 'newest' | 'oldest'

export interface InboxState {
  selectedInspectionId?: string
  drawerOpen: boolean
  filters: InboxFilterState
  pagination: InboxPaginationState
  sortDirection: InboxSortDirection
}

export type EnrichedGeckoInspectionData = GeckoInspection['data'] & {
  derivedStatus: InspectionStatus
  unitName?: string
  componentName?: string
  jobName?: string
  percentageProgress: number
  scanArea: GeckoMeasurement
  maximumPossibleScanArea: GeckoMeasurement
  indicationCount: number
  indicationsByType: Record<
    IndicationSetType,
    Array<{ indicationSet: IndicationSet; indications: IndicationItem[] }>
  >
  worstDRA?: number
}

export type EnrichedGeckoInspection = GeckoInspection & {
  data: EnrichedGeckoInspectionData
}
